export default __webpack_public_path__ + "456a037d92e58964175d359420fc42f2.svg";